import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';

const PhotoGallery = ({ listingId }) => {
    const [photos, setPhotos] = useState([]);
    const [selected, setSelected] = useState(null);
    const [uploading, setUploading] = useState(false);

    // Set your fixed listing_id here
    // const fixedListingId = 123; // Change this to the actual listing_id you want to send

    // Fetch photos
    useEffect(() => {
        const fetchPhotos = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/getPhotos.php?listing_id=${listingId}`);
                const data = await response.json();

                if (data.success) {
                    console.log('Fetched photos:', data.photos);
                    setPhotos(
                        data.photos.map(img => ({
                            src: img.url || img, // API ke hisab se
                            alt: img.caption || 'Uploaded Photo'
                        }))
                    );
                } else {
                    console.error('Failed to fetch photos:', data.message);
                }
            } catch (error) {
                console.error('Error fetching photos:', error);
            }
        };

        fetchPhotos();
    }, [API_BASE_URL, listingId]);

    // Handle file upload with fixed listing_id
    const handlePhotoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('photo', file);
        formData.append('listing_id', listingId); // Pass the correct listing_id

        setUploading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/uploadPhoto.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                setPhotos((prev) => [...prev, { src: `${API_BASE_URL}/${data.filePath}`, alt: file.name }]);
                alert(data.message);
            } else {
                alert(data.message);
            }
        } catch (error) {
            console.error('Error uploading photo:', error);
            alert('Failed to upload photo.');
        } finally {
            setUploading(false);
        }
    };

    if (!listingId) {
        return <div style={{color: 'red'}}>Invalid or missing listing_id.</div>;
    }

    return (
        <div>
            <h2>Photo Gallery</h2>
            <input type="file" onChange={handlePhotoUpload} disabled={uploading} />
            {uploading && <p>Uploading...</p>}
            <div>
                {photos.map((photo, index) => (
                    <img
                        key={index}
                        src={photo.src}
                        alt={photo.alt}
                        style={{ width: '100px', margin: '5px' }}
                    />
                ))}
            </div>
        </div>
    );
};

export default PhotoGallery;